import { defineComponent as _defineComponent } from 'vue'
import TileDropdownMainMenu from '@/components/SideBar/Tiles/TileDropdownMenu/TileDropdownMainMenu.vue';
import TileDropdownMenuFooter from '@/components/SideBar/Tiles/TileDropdownMenu/TileDropdownMenuFooter.vue';
import TileDropdownMenuHeader from '@/components/SideBar/Tiles/TileDropdownMenu/TileDropdownMenuHeader.vue';
import TileDropdownButtonStatus from '@/components/SideBar/Tiles/TileDropdownMenu/TileDropdownButtonStatus.vue';

import { TileWithWorkflow } from './types';
import { computed } from 'vue';
import { Service, ExperienceWorkflowWithContext } from '@ply-io/ply-front-shared-utilities';
interface TileDropdownMenuProps {
	tile: TileWithWorkflow;
	value: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TileDropdownMenu',
  props: {
    tile: null,
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({ (e: 'input', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
	tile: TileWithWorkflow;
	value: boolean;
}



const workflow = computed<ExperienceWorkflowWithContext>(() => props.tile.workflow);
const service = computed<Service>(() => props.tile.service);
const isOpen = computed({
	get: () => props.value,
	set: (value: boolean) => emits('input', value),
});

return { __sfc: true,props, emits, workflow, service, isOpen, TileDropdownMainMenu, TileDropdownMenuFooter, TileDropdownMenuHeader, TileDropdownButtonStatus }
}

})